export default __webpack_public_path__ + "static/media/ic-container.447945e6.svg";